module.exports = __webpack_public_path__ + "img/confirm_icon.a9301e33.svg";